/**
 * V3Icon — Iconoir, in the house register.
 *
 * Stroke paths from iconoir-react@7.12.1 (MIT, https://iconoir.com/). The
 * npm package is installed so a client island can import any Iconoir name;
 * this wrapper inlines the house set as RSC-safe SVG so chrome, doors, and
 * quiet marks do not become client islands (payload / LCP hold).
 *
 * currentColor, 24 grid, stroke 1.5. Never pass a hex. Marks differentiate
 * a door or a control; they are not a card grid of icons (TASTE.md).
 *
 * Re-extract the path table when bumping iconoir-react.
 */

const ICONS = {
  "Phone": [
    "M18.1182 14.702L14 15.5C11.2183 14.1038 9.5 12.5 8.5 10L9.26995 5.8699L7.81452 2L4.0636 2C2.93605 2 2.04814 2.93178 2.21654 4.04668C2.63695 6.83 3.87653 11.8765 7.5 15.5C11.3052 19.3052 16.7857 20.9564 19.802 21.6127C20.9668 21.8662 22 20.9575 22 19.7655L22 16.1812L18.1182 14.702Z"
  ],
  "ChatBubble": [
    "M17 12.5C17.2761 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.2761 11.5 17 11.5C16.7239 11.5 16.5 11.7239 16.5 12C16.5 12.2761 16.7239 12.5 17 12.5Z",
    "M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z",
    "M7 12.5C7.27614 12.5 7.5 12.2761 7.5 12C7.5 11.7239 7.27614 11.5 7 11.5C6.72386 11.5 6.5 11.7239 6.5 12C6.5 12.2761 6.72386 12.5 7 12.5Z",
    "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.8214 2.48697 15.5291 3.33782 17L2.5 21.5L7 20.6622C8.47087 21.513 10.1786 22 12 22Z"
  ],
  "Mail": [
    "M7 9L12 12.5L17 9",
    "M2 17V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17Z"
  ],
  "Calendar": [
    "M15 4V2M15 4V6M15 4H10.5M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10H3Z",
    "M3 10V6C3 4.89543 3.89543 4 5 4H7",
    "M7 2V6",
    "M21 10V6C21 4.89543 20.1046 4 19 4H18.5"
  ],
  "User": [
    "M5 20V19C5 15.134 8.13401 12 12 12V12C15.866 12 19 15.134 19 19V20",
    "M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
  ],
  "Star": [
    "M8.58737 8.23597L11.1849 3.00376C11.5183 2.33208 12.4817 2.33208 12.8151 3.00376L15.4126 8.23597L21.2215 9.08017C21.9668 9.18848 22.2638 10.0994 21.7243 10.6219L17.5217 14.6918L18.5135 20.4414C18.6409 21.1798 17.8614 21.7428 17.1945 21.3941L12 18.678L6.80547 21.3941C6.1386 21.7428 5.35909 21.1798 5.48645 20.4414L6.47825 14.6918L2.27575 10.6219C1.73617 10.0994 2.03322 9.18848 2.77852 9.08017L8.58737 8.23597Z"
  ],
  "GraphUp": [
    "M20 20H4V4",
    "M4 16.5L12 9L15 12L19.5 7.5"
  ],
  "Clock": [
    "M12 6L12 12L18 12",
    "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  ],
  "MapPin": [
    "M20 10C20 14.4183 12 22 12 22C12 22 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z",
    "M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z"
  ],
  "Page": [
    "M4 21.4V2.6C4 2.26863 4.26863 2 4.6 2H16.2515C16.4106 2 16.5632 2.06321 16.6757 2.17574L19.8243 5.32426C19.9368 5.43679 20 5.5894 20 5.74853V21.4C20 21.7314 19.7314 22 19.4 22H4.6C4.26863 22 4 21.7314 4 21.4Z",
    "M8 10L16 10",
    "M8 18L16 18",
    "M8 14L12 14",
    "M16 2V5.4C16 5.73137 16.2686 6 16.6 6H20"
  ],
  "OpenNewWindow": [
    "M21 3L15 3M21 3L12 12M21 3V9",
    "M21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H11"
  ],
  "NavArrowDown": [
    "M6 9L12 15L18 9"
  ],
  "Menu": [
    "M3 5H21",
    "M3 12H21",
    "M3 19H21"
  ],
  "Xmark": [
    "M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426"
  ],
  "Play": [
    "M6.90588 4.53682C6.50592 4.2998 6 4.58808 6 5.05299V18.947C6 19.4119 6.50592 19.7002 6.90588 19.4632L18.629 12.5162C19.0211 12.2838 19.0211 11.7162 18.629 11.4838L6.90588 4.53682Z"
  ],
  "ArrowRight": [
    "M3 12L21 12M21 12L12.5 3.5M21 12L12.5 20.5"
  ],
  "InfoCircle": [
    "M12 11.5V16.5",
    "M12 7.51L12.01 7.49889",
    "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  ],
  "Home": [
    "M2 8L11.7317 3.13416C11.9006 3.04971 12.0994 3.0497 12.2683 3.13416L22 8",
    "M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V11"
  ],
  "HomeSale": [
    "M14 9.84631C13 8.92323 10.3333 8.61555 10.3333 10.4617C10.3333 12.3079 14 11.3848 14 13.2309C14 15.0771 11 15.0771 10 13.8463",
    "M12 14.7021V16",
    "M12 9.11306V8",
    "M2 8L11.7317 3.13416C11.9006 3.04971 12.0994 3.0497 12.2683 3.13416L22 8",
    "M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V11"
  ],
  "Building": [
    "M10 9.01L10.01 8.99889",
    "M14 9.01L14.01 8.99889",
    "M10 13.01L10.01 12.9989",
    "M14 13.01L14.01 12.9989",
    "M10 17.01L10.01 16.9989",
    "M14 17.01L14.01 16.9989",
    "M6 20.4V5.6C6 5.26863 6.26863 5 6.6 5H12V3.6C12 3.26863 12.2686 3 12.6 3H17.4C17.7314 3 18 3.26863 18 3.6V20.4C18 20.7314 17.7314 21 17.4 21H6.6C6.26863 21 6 20.7314 6 20.4Z"
  ],
  "BellNotification": [
    "M18.1336 11C18.7155 16.3755 21 18 21 18H3C3 18 6 15.8667 6 8.4C6 6.70261 6.63214 5.07475 7.75736 3.87452C8.88258 2.67428 10.4087 2 12 2C12.3373 2 12.6717 2.0303 13 2.08949",
    "M19 8C20.6569 8 22 6.65685 22 5C22 3.34315 20.6569 2 19 2C17.3431 2 16 3.34315 16 5C16 6.65685 17.3431 8 19 8Z",
    "M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
  ],
  "Instagram": [
    "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    "M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z",
    "M17.5 6.51L17.51 6.49889"
  ],
  "Facebook": [
    "M17 2H14C12.6739 2 11.4021 2.52678 10.4645 3.46447C9.52678 4.40215 9 5.67392 9 7V10H6V14H9V22H13V14H16L17 10H13V7C13 6.73478 13.1054 6.48043 13.2929 6.29289C13.4804 6.10536 13.7348 6 14 6H17V2Z"
  ],
  "Youtube": [
    "M14 12L10.5 14V10L14 12Z",
    "M2 12.7075V11.2924C2 8.39705 2 6.94939 2.90549 6.01792C3.81099 5.08645 5.23656 5.04613 8.08769 4.96549C9.43873 4.92728 10.8188 4.8999 12 4.8999C13.1812 4.8999 14.5613 4.92728 15.9123 4.96549C18.7634 5.04613 20.189 5.08645 21.0945 6.01792C22 6.94939 22 8.39705 22 11.2924V12.7075C22 15.6028 22 17.0505 21.0945 17.9819C20.189 18.9134 18.7635 18.9537 15.9124 19.0344C14.5613 19.0726 13.1812 19.1 12 19.1C10.8188 19.1 9.43867 19.0726 8.0876 19.0344C5.23651 18.9537 3.81097 18.9134 2.90548 17.9819C2 17.0505 2 15.6028 2 12.7075Z"
  ],
  "Tiktok": [
    "M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z",
    "M10 12C8.34315 12 7 13.3431 7 15C7 16.6569 8.34315 18 10 18C11.6569 18 13 16.6569 13 15V6C13.3333 7 14.6 9 17 9"
  ],
  "X": [
    "M16.8198 20.7684L3.75317 3.96836C3.44664 3.57425 3.72749 3 4.22678 3H6.70655C6.8917 3 7.06649 3.08548 7.18016 3.23164L20.2468 20.0316C20.5534 20.4258 20.2725 21 19.7732 21H17.2935C17.1083 21 16.9335 20.9145 16.8198 20.7684Z",
    "M20 3L4 21"
  ],
  "Linkedin": [
    "M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z",
    "M7 17V13.5V10",
    "M11 17V13.75M11 10V13.75M11 13.75C11 10 17 10 17 13.75V17",
    "M7 7.01L7.01 6.99889"
  ]
} as const

export type V3IconName = keyof typeof ICONS

export const V3_ICON_NAMES = Object.freeze(Object.keys(ICONS)) as readonly V3IconName[]

/** Quiet channel marks that are Iconoir. `supply` stays the MOS two-bar drawing. */
export const QUIET_MARK_ICON = {
  call: 'Phone',
  text: 'ChatBubble',
  email: 'Mail',
  schedule: 'Calendar',
  person: 'User',
  review: 'Star',
  market: 'GraphUp',
  history: 'Clock',
  map: 'MapPin',
  page: 'Page',
  external: 'OpenNewWindow',
} as const satisfies Record<string, V3IconName>

export type V3IconSize = 16 | 18 | 20 | 24 | 40

export type V3IconProps = {
  name: V3IconName
  size?: V3IconSize
  className?: string
  /** When set, the svg is labelled and not aria-hidden. */
  title?: string
}

export function V3Icon({ name, size = 20, className, title }: V3IconProps) {
  const paths = ICONS[name]
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
      className={className}
    >
      {paths.map((d) => (
        <path
          key={d}
          d={d}
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  )
}
